(function () {
  if (window.__bramhallWishlistDrawerInit) return;
  window.__bramhallWishlistDrawerInit = true;

  var STORAGE_KEY = 'bramhall_wishlist';

  function getWishlist() {
    if (window.BramhallWishlist && typeof window.BramhallWishlist.get === 'function') {
      return window.BramhallWishlist.get();
    }
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function removeFromWishlist(id) {
    if (window.BramhallWishlist && typeof window.BramhallWishlist.toggle === 'function') {
      window.BramhallWishlist.toggle(id);
    }
  }

  function getProductData() {
    var script = document.getElementById('WishlistDrawer-ProductData');
    if (!script) return {};
    try {
      return JSON.parse(script.textContent) || {};
    } catch (e) {
      return {};
    }
  }

  function escapeHtml(value) {
    var div = document.createElement('div');
    div.textContent = value == null ? '' : String(value);
    return div.innerHTML;
  }

  var REMOVE_ICON =
    '<svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M5 5l10 10M15 5L5 15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';

  class WishlistDrawer extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('keyup', function (evt) {
        if (evt.code === 'Escape') this.close();
      }.bind(this));

      var overlay = this.querySelector('#WishlistDrawer-Overlay');
      if (overlay) overlay.addEventListener('click', this.close.bind(this));

      this.setHeaderIconAccessibility();
      this.render();

      window.addEventListener('wishlist:changed', this.render.bind(this));
    }

    setHeaderIconAccessibility() {
      var trigger = document.querySelector('#wishlist-icon-bubble');
      if (!trigger) return;

      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        this.open(trigger);
      }.bind(this));
      trigger.addEventListener('keydown', function (event) {
        if (event.code && event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(trigger);
        }
      }.bind(this));
    }

    open(triggeredBy) {
      if (this.classList.contains('active')) return;
      if (triggeredBy) this.activeElement = triggeredBy;

      setTimeout(function () {
        this.classList.add('active');
      }.bind(this));

      this.addEventListener(
        'transitionend',
        function () {
          var container = this.classList.contains('is-empty')
            ? this.querySelector('.wishlist-drawer__empty')
            : this.querySelector('.wishlist-drawer__inner');
          var focusEl = this.querySelector('.wishlist-drawer__inner') || this.querySelector('.wishlist-drawer__close');
          if (typeof trapFocus === 'function' && container) trapFocus(container, focusEl);
        }.bind(this),
        { once: true }
      );

      document.body.classList.add('overflow-hidden');
    }

    close() {
      this.classList.remove('active');
      if (typeof removeTrapFocus === 'function') removeTrapFocus(this.activeElement);
      document.body.classList.remove('overflow-hidden');
    }

    render() {
      var ids = getWishlist();
      var products = getProductData();
      var grid = this.querySelector('#WishlistDrawer-Grid');
      if (!grid) return;

      var validIds = ids.filter(function (id) {
        return !!products[id];
      });

      this.classList.toggle('is-empty', validIds.length === 0);

      grid.innerHTML = '';

      validIds.forEach(function (id) {
        var product = products[id];
        var li = document.createElement('li');
        li.className = 'wishlist-drawer__item';

        var media = product.image
          ? '<img src="' + product.image + '" alt="" loading="lazy" width="160" height="200">'
          : '';

        var priceHtml = '';
        if (product.compareAtPrice) {
          priceHtml += '<s>' + escapeHtml(product.compareAtPrice) + '</s> ';
        }
        priceHtml += escapeHtml(product.price);

        li.innerHTML =
          '<a href="' + product.url + '" class="wishlist-drawer__item-media">' + media + '</a>' +
          '<div class="wishlist-drawer__item-info">' +
            '<a href="' + product.url + '" class="wishlist-drawer__item-title">' + escapeHtml(product.title) + '</a>' +
            '<p class="wishlist-drawer__item-price">' + priceHtml + '</p>' +
            (product.available === false ? '<p class="wishlist-drawer__item-soldout">Sold out</p>' : '') +
          '</div>' +
          '<button type="button" class="wishlist-drawer__item-remove" aria-label="Remove from wishlist" data-remove-id="' + id + '">' +
            REMOVE_ICON +
          '</button>';

        grid.appendChild(li);
      });

      grid.querySelectorAll('[data-remove-id]').forEach(function (button) {
        button.addEventListener('click', function () {
          removeFromWishlist(button.getAttribute('data-remove-id'));
        });
      });

      this.updateBubble(validIds.length);
    }

    updateBubble(count) {
      var bubble = document.getElementById('WishlistCountBubble');
      var value = document.getElementById('WishlistCountValue');
      if (!bubble || !value) return;
      value.textContent = count;
      bubble.hidden = count === 0;
    }
  }

  customElements.define('wishlist-drawer', WishlistDrawer);
})();
